import { mapState, mapGetters, mapActions } from 'vuex'


export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const companiesComputed = {
  ...mapState('companies', {}),
  ...mapGetters('companies', []),
}

export const authMethods = mapActions(
  'auth', ['logIn', 'logOut', 'validate', 'register', 'resetPassword']
)

export const companiesMethods = mapActions(
  'companies', [
    'createCompany',
    'updateCompany',
    'companyDetails',
    'fetchCorporates',
    'fetchApiPartners',
    'updateCompanyField',
    'changeToken',
    'companyProducts',
    'companyAssignProducts',
    'companyDiscounts',
    'companyActiveProducts',
    'discountData',
    'assignDiscount']
)

export const ordersMethods = mapActions(
  'orders', [
    'dashboardOrders',
    'dashboardUsers',
    'fetchOrders',
    'fetchSuccessOrders',
    'fetchPendingOrders',
    'fetchFailedOrders',
    'orderStatus'
  ]
)

export const fundRequestMethods = mapActions(
  'fundRequests', [
    'requestHistory',
    'actionFund'
  ]
)

export const eMoneyMethods = mapActions(
  'eMoney', [
    'createEMoney',
    'eMoneyHistory'
  ]
)

export  const apiPartnerMethods = mapActions(
  'apiPartners', [
    'apiPartnerDropDown'
  ]
)

export const reportMethods = mapActions(
  'reports', ['orderReports', 'ledger']
)

export const dashBoardMethods = mapActions(
  'dashBoard', ['widgets', 'walletWidgets', 'graphs', 'topSelling', 'recentOrders', 'monthGraph']
)

export const productMethods = mapActions(
  'products', ['fetchProducts', 'assignDiscount']
)